// composables/useGeoMap.ts
import L from 'leaflet';
import { CustomUiUserAvatar } from "#components";
import { render } from "vue";
import type { PortfolioType } from "~/types/Portfolio";

export function useGeoMap() {
    const map = ref(null);
    const zoom = ref(11);
    const center = ref({ lat: 25.057257, lng: 55.207695 });
    const userLocation = ref<any>(null);
    const bounds = ref(null)

    function locateUser() {
        map.value?.leafletObject?.locate();
    }

    function onLocationFound(location: any) {
        userLocation.value = location.latlng
        center.value = location.latlng
        const {filterBounds} = useBoundsCalculator(location.latlng)
        if(filterBounds){
            bounds.value = filterBounds.value
        }
        map.value?.leafletObject?.panTo(location.latlng)
    }

    const markersLayer = ref(null)

    async function setupMarkers(mastersList: PortfolioType[]) {
        if (!map.value?.leafletObject) return;
        if (markersLayer.value) {
            map.value.leafletObject.removeLayer(markersLayer.value)
        }

        const {markers, markerCluster} = await useLMarkerCluster({
            leafletObject: map.value.leafletObject,
            markers: mastersList
                .filter(item => !!item.geo && !!item.user)
                .map(item => {
                    const markerContainer = document.createElement('div');
                    markerContainer.className = 'w-11 h-11 rounded-full border-2 border-white shadow-md cursor-pointer flex items-center justify-center';

                    render(
                        h(CustomUiUserAvatar, {
                            src: item.user.avatar?.formats?.small?.url,
                            name: item.user.username,
                            size: 'xs',
                        }),
                        markerContainer
                    );

                    return {
                        name: item.user.username,
                        lat: item.geo.lat,
                        lng: item.geo.lng,
                        options: {
                            icon: L.divIcon({
                                html: markerContainer.outerHTML,
                                className: 'custom-marker',
                                iconSize: [48, 48],
                            }),
                            documentId: item.documentId,
                        },
                    };
                })
        });

        markersLayer.value = markerCluster

        markers.forEach(marker => {
            marker.on('click', (event) => {
                if (!event?.target?.options?.documentId) return;
                navigateTo({
                    name: 'portfolio',
                    params: { id: event.target.options.documentId },
                    query: { mode: 'geo' }
                });
            });
        });
    }

    return {
        map,
        zoom,
        center,
        userLocation,
        bounds,
        locateUser,
        onLocationFound,
        setupMarkers
    };
}